import { ChildConnectionFormVM } from '../child-connection-form.viewmodel';
import { ConnectionType, IChildConnectionDTO, IConnectionDetailsDTO } from '../../../../../../api/connections.dao';
import { configList, UDIFieldKey } from './unique-dial-in-child-connection.config';


export class UniqueDialInChildConnectionVM extends ChildConnectionFormVM {

    constructor(
        accountId: number,
        eventId: number,
        childConnection: IChildConnectionDTO,
        parentConnectionDetails: IConnectionDetailsDTO,
        onChildConnectionUpdated: (childConnection: IChildConnectionDTO, parentConnectionId: number) => void
    ) {
        super(accountId, eventId, childConnection, parentConnectionDetails, onChildConnectionUpdated);
        this.initFormDataCtrl(configList, this.composeInitialData(childConnection, parentConnectionDetails));
    }

    public get type(): ConnectionType { return ConnectionType.UniqueDialIn; }

    public async updateChildConnection(): Promise<boolean> {
        return super.updateChildConnection(this.composeUpdateChildConnectionDetails());
    }

    private composeInitialData(child: IChildConnectionDTO, parent: IConnectionDetailsDTO): Partial<IChildConnectionDTO> {
        const initial = { ...child };
        initial[UDIFieldKey.PROVIDER] = parent[UDIFieldKey.PROVIDER];
        initial[UDIFieldKey.AUDIO_BRIDGE_NAME] = parent[UDIFieldKey.AUDIO_BRIDGE_NAME];

        return initial;
    }

    private composeUpdateChildConnectionDetails(): Partial<IChildConnectionDTO> {
        return {
            type: this.type,
            userId: this.formDataCtrl.getValue(UDIFieldKey.USER_ID) as string,
            uniqueDialInCode: this.formDataCtrl.getValue(UDIFieldKey.PARTICIPANT_ID) as string,
            joinMethodId: this.childConnection.joinMethodId,
            parentJoinMethodId: this.parentConnectionDetails.joinMethodId
        };
    }

}